export const EMBROIDERY_POSITIONS = [
  { label: '踵サイド部(右足)', value: 'healSideRightFoot' },
  { label: '踵サイド部(左足)', value: 'healSideLeftFoot' },
  { label: '踵中央部(右足)', value: 'healCenterRightFoot' },
  { label: '踵中央部(左足)', value: 'healCenterLeftFoot' },
  { label: '踵かざり部(両足)', value: 'healDecoration' } // 2箇所分の刺繍料金がかかる
]
export const EMBROIDERY_TYPE_FACES = [
  { label: '活字体', value: 'sans-serif' }, // ゴシック体
  { label: '漢字(楷書体)', value: 'serif' }, // 明朝体
  { label: '筆記体', value: 'cursive' }, // 筆記体
  { label: 'ブラッシュ体', value: 'Brush Script MT' },
  { label: 'ブロック体(英字)', value: 'block' }
]
